export const ItemsPageLayout = ({ children }) => {
  return (
    <div className="content" id="items-page">
      {children}
    </div>
  );
};
